module.exports = __webpack_public_path__ + "img/icon-code.13e8d06e.svg";